/** Copyright (c) 2018, MOBICOOP. All rights reserved. This project is dual
licensed under AGPL and proprietary licence. This program is free software: you
can redistribute it and/or modify it under the terms of the GNU Affero General
Public License as published by the Free Software Foundation, either version 3 of
the License, or (at your option) any later version. This program is distributed
in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the
implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details. You should have received a
copy of the GNU Affero General Public License along with this program. If not,
see gnu.org/licenses. Licence MOBICOOP described in the file LICENSE
**************************/

<template>
  <ion-card
    v-if="!!user && user.missingDataToPayElectronically.length > 0"
    class="ion-no-margin"
    style="margin-bottom: 30px"
    color="warning"
    @click="$router.push({ name: 'bank-account' })"
  >
    <ion-card-content class="d-flex">
      <ion-icon
        style="
          min-height: 25px;
          min-width: 25px;
          margin-top: 3px;
          margin-right: 16px;
        "
        name="alert"
      ></ion-icon>
      <div>
        <div style="margin-bottom: 4px">
          <b>{{ $t(`data-to-pay.title`) }}</b>
        </div>
        <div>
          {{ $t(`data-to-pay.subtitle`) }} :
        </div>
        <ul class="ion-no-margin ion-margin-top">
          <li v-for="item in user.missingDataToPayElectronically">
            {{ $t(`data-to-pay.${item}`) }}
          </li>
        </ul>
      </div>
    </ion-card-content>
  </ion-card>
</template>
<style lang="scss"></style>
<script>
export default {
  name: "data-to-pay-alert",
  props: [],
  data: function () {
    return {};
  },
  computed: {
    user: {
      get() {
        return this.$store.state.userStore.user;
      },
    },
  },
  methods: {},
};
</script>
